import { IGraphLayoutDetails } from "../Questions/GraphLayoutDetails/graphLayoutDetails";
export class GraphLayoutDetail implements IGraphLayoutDetails {
    cellSize: number;
    quadView: string;
    XN: number;
    XP: number;
    YN: number;
    YP: number;
    xInterval: number;
    yInterval: number;
    constructor(cellSize: number, quadView: string, XN: number, XP: number, YN: number, YP: number, xInterval: number, yInterval: number) {
        this.cellSize = cellSize;
        this.quadView = quadView;
        this.XN = XN;
        this.XP = XP;
        this.YN = YN;
        this.YP = YP;
        this.xInterval = xInterval;
        this.yInterval = yInterval;
    }
}


// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/_models/Questions/question.interface.ts